export default "__VITE_ASSET__C_2SgxBc__"